// extracted by mini-css-extract-plugin
export default {"TrustedReviewers":"oSBtVlMtvDCNZbV4pM0k","h2":"xWtkwrf2gqdByWYD7vLg","TrustedReviewerWrapper":"tsfklctPbziKHgbWW0jc"};